export default {
  name: 'AdnAlert',
  props: {
    centered: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      validator: val => ['basic', 'inverted'].includes(val)
    },
    kind: {
      type: String,
      validator: val => ['success', 'info', 'danger'].includes(val)
    }
  },
  computed: {
    classNames() {
      const classNames = ['adn-alert', `adn-alert--${this.kind}`]
      if (this.theme && this.theme !== 'basic') {
        classNames.push(`adn-alert--${this.theme}`)
      }
      if (this.centered) {
        classNames.push('adn-alert--centered')
      }
      return classNames
    },
    iconClassNames() {
      const iconClassNames = ['adn-icon']
      if (this.kind === 'success') {
        iconClassNames.push('adn-icon--status-check')
      } else if (this.kind === 'info') {
        iconClassNames.push('adn-icon--function-information')
      } else if (this.kind === 'warning') {
        iconClassNames.push('adn-icon--function-warning')
      } else if (this.kind === 'danger') {
        iconClassNames.push('adn-icon--status-unavailable')
      }
      return iconClassNames
    }
  }
}
